<div class="screen">
  <app-navbar></app-navbar>

  <div class="page">
    <div class="header-section">
      <h1 class="dashboard-title">Settlement Details</h1>

      <div class="header-right">
        <div class="date-picker-badge">
          <button class="nav-btn" (click)="changeDay(-1)" [disabled]="isLoading">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>
          
          <div class="date-display" (click)="picker.open()" style="cursor: pointer;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2.2"
                 stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
              <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"/>
            </svg>
            <span>{{ selectedDate | date:'dd MMMM yyyy' }}</span>
            <input matInput [matDatepicker]="picker" 
                   [value]="selectedDate" 
                   (dateChange)="onMatDateChange($event)" 
                   [max]="maxDate"
                   style="position: absolute; opacity: 0; width: 0; height: 0; pointer-events: none;">
            <mat-datepicker #picker panelClass="premium-calendar"></mat-datepicker>
          </div>

          <button class="nav-btn" (click)="changeDay(1)" [disabled]="isLoading || selectedDate >= maxDate">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="list-container">
        <div class="list-controls">
          <div class="search-wrap">
            <svg class="search-icon-svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
            <input
              class="search-input"
              type="text"
              placeholder="Search"
              [value]="searchTerm"
              (input)="onSearchChange($event)"
            />
          </div>
          <div class="controls-right">
            <div
              class="filter-attached"
              role="group"
              aria-label="Filter controls"
            >
              <div class="filter-by">Filter By</div>
              <div class="filter-select-pill">
                <select
                  id="filter"
                  class="filter-select"
                  aria-label="Filter by bid type"
                  [value]="selectedBidType"
                  (change)="onFilterChange($event)"
                >
                  <option value="All">All</option>
                  <option value="Buy">Buy</option>
                  <option value="Sell">Sell</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="table-head">
          <div class="col col-no">No.</div>
          <div class="col col-customer-name">Customer Name ( Meter ID )</div>
          <div class="col col-bid-type">Bid Type</div>
          <div class="col col-bid-price">Bid Price</div>
          <div class="col col-units">Units</div>
          <div class="col col-strike-price">Strike Price</div>
          <div class="col col-allotted">Allotted Units</div>
          <div class="col col-untraded">Untraded Units</div>
        </div>

        <div *ngIf="isLoading || errorMessage" class="center-message-wrapper">
          <div *ngIf="isLoading" class="center-message">
            <div class="spinner"></div>
            <span>Loading settlements...</span>
          </div>
          <div *ngIf="errorMessage" class="center-message error">
            <span>{{ errorMessage }}</span>
          </div>
        </div>
        <div
          *ngIf="
            !isLoading && !errorMessage && filteredSettlements.length === 0
          "
          class="center-message-wrapper"
        >
          <div class="center-message">
            <span>{{
              masterSettlements.length > 0
                ? "No results match your filters."
                : "No settlement details found for the selected date."
            }}</span>
          </div>
        </div>

        <ul
          class="settlement-list"
          role="list"
          *ngIf="!isLoading && !errorMessage && filteredSettlements.length > 0"
        >
          <li
            class="settlement-row"
            *ngFor="let s of filteredSettlements; let i = index"
            role="listitem"
          >
            <div class="col col-no">{{ i + 1 }}</div>
            <div class="col col-customer-name bold-col">{{ s.customer_name }}</div>
            <div class="col col-bid-type">{{ s.bid_type }}</div>
            <div class="col col-bid-price">{{ s.bid_price }}</div>
            <div class="col col-units">{{ s.units }}</div>
            <div class="col col-strike-price">{{ s.strike_price }}</div>
            <div class="col col-allotted">{{ s.allotted_units }}</div>
            <div class="col col-untraded">{{ s.untraded_units }}</div>
          </li>
        </ul>
      </div>
    <div class="dashboard-footer">Powered By Hygge Energy</div>
  </div>
</div>
